import {Contact} from "../../common/model/contact";

export class Executor {
    id?: string;
    label: string;
    email?: string;
    active?: boolean;
    isLinkedToAllBuildings?: boolean;
    defaultLinks?: ExecutorDefaultLink[];
    buildingIds?: string[];
    createdOn?: Date;
    contacts?: Contact[]
  }


export class ExecutorDefaultLink{
  buildingGuid: string;
  actionTypes: string[];
}
